const baseTheme = {
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem'
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px'
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    fontSize: {
      small: '0.875rem',
      medium: '1rem',
      large: '1.25rem',
      xlarge: '1.5rem'
    },
    fontWeight: {
      regular: 400,
      medium: 500,
      bold: 700
    }
  },
  shadows: {
    small: '0 2px 4px rgba(0,0,0,0.1)',
    medium: '0 4px 8px rgba(0,0,0,0.1)',
    large: '0 8px 16px rgba(0,0,0,0.1)'
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    round: '50%'
  }
};

export const lightTheme = {
  ...baseTheme,
  colors: {
    primary: '#0d47a1',
    'primary-light': '#e3f2fd',
    'primary-dark': '#002171',
    secondary: '#212121',
    error: '#9b0000', // Darker red for better contrast with white text
    'error-light': '#ffebee',
    'error-contrast': '#ffffff', // White for better contrast with error
    success: '#1b5e20',
    'success-light': '#e8f5e9',
    'success-contrast': '#ffffff', // White for better contrast with success
    neutral: '#424242',
    'background-primary': '#FFFFFF',
    'background-secondary': '#F8F9FA',
    'background-hover': '#E2E8F0',
    'text-primary': '#000000',
    'text-secondary': '#212121',
    'border-color': '#212121',
    'button-text': '#ffffff',
    'button-bg': '#0d47a1',
    'surface-color': '#FFFFFF',
    'success-color': '#1b5e20',
    'error-color': '#9b0000', // Match error color
    'background-color': '#FFFFFF',
    'link-color': '#0d47a1', // Link color for light theme
    'link-hover-color': '#002171' // Link hover color for light theme
  }
};

export const darkTheme = {
  ...baseTheme,
  colors: {
    primary: '#90caf9', // Desaturated blue for better readability
    'primary-light': '#1a237e',
    'primary-dark': '#5d99c6', // Desaturated version of primary
    secondary: '#e1e1e1', // Slightly off-white for better eye comfort
    error: '#a00000', // Darker red for better contrast with white text
    'error-light': '#3f2424',
    'error-contrast': '#ffffff', // Pure white for maximum contrast with error
    success: '#1b5e20', // Brighter green for better contrast with white text
    'success-light': '#243524',
    'success-contrast': '#ffffff', // Pure white for maximum contrast with success
    neutral: '#bdbdbd',
    'background-primary': '#121212', // Very dark gray for better contrast with secondary
    'background-secondary': '#616161', // Further increased contrast with primary background
    'background-hover': '#808080', // Increased contrast for hover states
    'text-primary': '#f5f5f5', // Off-white instead of pure white
    'text-secondary': '#d0d0d0', // Light gray for secondary text
    'border-color': '#d0d0d0', // Light gray instead of pure white
    'button-text': '#121212', // Dark gray instead of pure black
    'button-bg': '#90caf9', // Matching primary color
    'surface-color': '#616161', // Same as background-secondary
    'success-color': '#1b5e20', // Same as success
    'error-color': '#a00000', // Same as error
    'background-color': '#121212', // Same as background-primary
    'link-color': '#90caf9', // Bright blue for links in dark mode
    'link-hover-color': '#bbdefb' // Lighter blue for link hover in dark mode
  },
  shadows: {
    small: '0 2px 4px rgba(0,0,0,0.3)',
    medium: '0 4px 8px rgba(0,0,0,0.3)',
    large: '0 8px 16px rgba(0,0,0,0.3)'
  }
};

// For backward compatibility
export const theme = lightTheme;